import { useEffect } from 'react';
import useNRQuery from '../../graphql/useNRQuery';
import NRNotificationsInAppContent from './NRNotificationsInAppContent';
import { GET_NOTIFICATIONS } from '../../graphql/queries/notifications';

function NRNotificationsInAppContainer({ onNotificationClick, onNotificationsLoaded, onMarkAllAsRead, onViewAllNotifications, assetId = null }) {
  const [notifications, loadingNotifications] = useNRQuery({
    query: GET_NOTIFICATIONS,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 20 },
          sort: {
            field: 'CREATEDAT',
            order: 'DESC'
          },
          ...(assetId && {
            filter: {
              assetId: {
                eq: assetId
              }
            }
          })
        }
      }
    },
    qlObjKey: 'notifications',
    defaultValue: [],
    transformData: data => {
      const toReturn = data?.edges?.map(item => item.node);
      return toReturn;
    }
  });

  // Notify parent when notifications are loaded
  useEffect(() => {
    if (onNotificationsLoaded && notifications) {
      onNotificationsLoaded(notifications);
    }
  }, [notifications, onNotificationsLoaded]);

  return (
    <NRNotificationsInAppContent
      notifications={notifications}
      isLoading={loadingNotifications}
      onNotificationClick={onNotificationClick}
      onMarkAllAsRead={onMarkAllAsRead}
      onViewAllNotifications={onViewAllNotifications}
    />
  );
}

export default NRNotificationsInAppContainer;
